import { Square, type LucideIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export function PlaceholderChip({
  label,
  value,
  icon: Icon = Square,
}: {
  label: string;
  value?: string | null;
  icon?: LucideIcon;
}) {
  if (value) {
    return (
      <Badge variant="secondary" className="font-normal gap-1.5">
        <Icon className="h-3 w-3" />
        {value}
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="font-normal gap-1.5 border-dashed text-muted-foreground">
      <Icon className="h-3 w-3" />
      {`{${label}}`}
    </Badge>
  );
}